import { BaseIconComponent } from "./BaseIcon";
import React from "react";

export function RotateScreenIconComponent() {
    return (
        <BaseIconComponent width="123.66" height="135.131">
            <defs>
                <clipPath id="clip-path">
                    <rect
                        id="Rectangle_1552"
                        data-name="Rectangle 1552"
                        width="98.746"
                        height="110.217"
                        fill="#0bfcff"
                    />
                </clipPath>
            </defs>
            <g
                id="Group_5627"
                data-name="Group 5627"
                transform="translate(-344.17 -99.933)"
            >
                <path
                    id="Path_21741"
                    data-name="Path 21741"
                    d="M98.746,11.417A11.431,11.431,0,0,0,87.328,0H51.566A11.431,11.431,0,0,0,40.148,11.417v30.69a1.338,1.338,0,0,0,2.677,0V11.417a8.751,8.751,0,0,1,8.741-8.741h13.02a2.116,2.116,0,0,0,1.968,2.9h4.64a2.115,2.115,0,0,0,1.968-2.9H87.328a8.751,8.751,0,0,1,8.741,8.741V55.7a11.4,11.4,0,0,0-8.741-4.083H11.417A11.431,11.431,0,0,0,0,63.037V98.8a11.431,11.431,0,0,0,11.417,11.417H87.328A11.431,11.431,0,0,0,98.746,98.8V11.417ZM87.328,107.541H11.417A8.751,8.751,0,0,1,2.677,98.8V85.206a2.115,2.115,0,0,0,2.9-1.968V78.6a2.115,2.115,0,0,0-2.9-1.968V63.037A8.751,8.751,0,0,1,11.417,54.3H87.328a8.751,8.751,0,0,1,8.741,8.737V98.8h0a8.751,8.751,0,0,1-8.741,8.74"
                    transform="translate(356.627 112.391)"
                    fill="#0bfcff"
                />
                <path
                    id="Path_21743"
                    data-name="Path 21743"
                    d="M48.339,58.985h0a.984.984,0,0,1,0,1.361h0l-6.892,6.892a.962.962,0,0,1-1.361-1.361l5.266-5.266H32.986a4.672,4.672,0,0,0-2.747.88,4.586,4.586,0,0,0-1.105,1.1,4.67,4.67,0,0,0-.882,2.749v5.679a.947.947,0,1,1-1.893,0v-5.57a6.662,6.662,0,0,1,.844-3.307,6.817,6.817,0,0,1,2.584-2.584,6.661,6.661,0,0,1,3.308-.844H45.351l-5.266-5.266a.962.962,0,1,1,1.361-1.36Z"
                    transform="translate(340.346 80.391)"
                    fill="#0bfcff"
                />
                <g
                    id="Group_5624"
                    data-name="Group 5624"
                    transform="translate(356.627 112.391)"
                >
                    <g
                        id="Group_5626"
                        data-name="Group 5626"
                        clipPath="url(#clip-path)"
                    >
                        <path
                            id="Path_21741-2"
                            data-name="Path 21741"
                            d="M98.746,11.417A11.431,11.431,0,0,0,87.328,0H51.566A11.431,11.431,0,0,0,40.148,11.417v30.69a1.338,1.338,0,0,0,2.677,0V11.417a8.751,8.751,0,0,1,8.741-8.741h13.02a2.116,2.116,0,0,0,1.968,2.9h4.64a2.115,2.115,0,0,0,1.968-2.9H87.328a8.751,8.751,0,0,1,8.741,8.741V55.7a11.4,11.4,0,0,0-8.741-4.083H11.417A11.431,11.431,0,0,0,0,63.037V98.8a11.431,11.431,0,0,0,11.417,11.417H87.328A11.431,11.431,0,0,0,98.746,98.8V11.417ZM87.328,107.541H11.417A8.751,8.751,0,0,1,2.677,98.8V85.206a2.115,2.115,0,0,0,2.9-1.968V78.6a2.115,2.115,0,0,0-2.9-1.968V63.037A8.751,8.751,0,0,1,11.417,54.3H87.328a8.751,8.751,0,0,1,8.741,8.737V98.8h0a8.751,8.751,0,0,1-8.741,8.74"
                            fill="#0bfcff"
                        />
                        <path
                            id="Path_21742"
                            data-name="Path 21742"
                            d="M48.339,58.985h0a.984.984,0,0,1,0,1.361h0l-6.892,6.892a.962.962,0,0,1-1.361-1.361l5.266-5.266H32.986a4.672,4.672,0,0,0-2.747.88,4.586,4.586,0,0,0-1.105,1.1,4.67,4.67,0,0,0-.882,2.749v5.679a.947.947,0,1,1-1.893,0v-5.57a6.662,6.662,0,0,1,.844-3.307,6.817,6.817,0,0,1,2.584-2.584,6.661,6.661,0,0,1,3.308-.844H45.351l-5.266-5.266a.962.962,0,1,1,1.361-1.36Z"
                            transform="translate(-16.281 -32)"
                            fill="#0bfcff"
                        />
                        <path
                            id="Path_21743-2"
                            data-name="Path 21743"
                            d="M48.339,58.985h0a.984.984,0,0,1,0,1.361h0l-6.892,6.892a.962.962,0,0,1-1.361-1.361l5.266-5.266H32.986a4.672,4.672,0,0,0-2.747.88,4.586,4.586,0,0,0-1.105,1.1,4.67,4.67,0,0,0-.882,2.749v5.679a.947.947,0,1,1-1.893,0v-5.57a6.662,6.662,0,0,1,.844-3.307,6.817,6.817,0,0,1,2.584-2.584,6.661,6.661,0,0,1,3.308-.844H45.351l-5.266-5.266a.962.962,0,1,1,1.361-1.36Z"
                            transform="translate(-16.281 -32)"
                            fill="#0bfcff"
                        />
                    </g>
                </g>
                <g
                    id="Rectangle_1553"
                    data-name="Rectangle 1553"
                    transform="translate(356 163)"
                    fill="#0bfcff"
                    stroke="#707070"
                    strokeWidth="1"
                    opacity="0.084"
                >
                    <rect width="99" height="60" rx="12" stroke="none" />
                    <rect
                        x="0.5"
                        y="0.5"
                        width="98"
                        height="59"
                        rx="11.5"
                        fill="none"
                    />
                </g>
            </g>
        </BaseIconComponent>
    );
}
